import { z } from "zod";

export const PostStripeCheckoutBodyInputSchema = z.object({
  priceId: z.string(),
  successUrl: z.string().url(),
  cancelUrl: z.string().url(),
  quantity: z.number().int().min(1).optional(),
});

export const PostStripeCheckoutOutputSchema = z.object({
  id: z.string(),
  url: z.string().nullish(),
});

export type StripeCheckoutInput = z.infer<typeof PostStripeCheckoutBodyInputSchema>;
export type StripeCheckoutOutput = z.infer<typeof PostStripeCheckoutOutputSchema>;
